import { redirectToLogin } from '../../utils/authRedirect';

/**
 * Middleware to handle authorization errors (401, 403).
 *
 * 401 durumunda token refresh + isteği yeniden deneme http.service.js
 * interceptor'ında yapılır; buraya 401 düşmesi "refresh de kurtaramadı"
 * demektir → oturumu temizle ve login'e dön.
 *
 * Yönlendirme kararı storage'da token olup olmamasına BAĞLANMAZ: korumalı
 * bir endpoint'e yetkili çağrı yapıldıysa uygulama kendini oturum açmış
 * sayıyordur. Storage başka bir sekme tarafından temizlenmiş olsa bile
 * (token yok) kullanıcıyı login'e götürmek gerekir; aksi halde SPA açık
 * kalır ve ekranlar API verisi olmadan boş görünür. Public sayfalarda
 * (login, şifremi unuttum vb.) yönlendirme yapılmaz.
 *
 * ÖNEMLİ: Aksiyon HER ZAMAN reducer'lara iletilir (next). Aksi halde
 * *_REJECTED aksiyonları yutulur, loading/initialized state'leri asılı
 * kalır ve ekran sonsuza dek beyaz kalır.
 */
export const handleAuthorization =
  () =>
  (next) =>
  (action) => {
    const result = next(action);

    const { payload } = action;
    const requestUrl = payload?.error?.config?.url || "";
    const isPublicRequest = requestUrl.includes("/public/");

    if (
      (payload?.status === 401 || payload?.status === 403) &&
      payload?.isHttpError &&
      !isPublicRequest
    ) {
      redirectToLogin();
    }

    return result;
  };
